// GypsyPage.js
import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './GypsyCarouselAndGallery.css';

const images = [
  { src: '/picz/horseshoebend2.jpg', alt: 'horseshoebend' },
  { src: '/picz/sierranev2.jpg', alt: 'nevada' },
  { src: '/picz/kanab1.jpg', alt: 'utah' },
  { src: '/picz/landsend1.jpg', alt: 'SF' },
  { src: '/picz/tahoe.jpg', alt: 'tahoe' },
  { src: '/picz/gypsygrandcanyonbg.jpg', alt: 'arizona' },
  { src: '/picz/finn.jpg', alt: 'finn' }
];

const GypsyCarousel = () => {
  const [likes, setLikes] = useState(Array(images.length).fill(0));
  const [comments, setComments] = useState(Array(images.length).fill([]));

  const handleLike = (index) => {
    const newLikes = [...likes];
    newLikes[index]++;
    setLikes(newLikes);
  };

  const handleComment = (e, index) => {
    if (e.key === 'Enter' && e.target.value.trim()) {
      const newComments = [...comments];
      // Add new comment at the start
      newComments[index] = [e.target.value.trim(), ...newComments[index]];
      setComments(newComments);
      e.target.value = '';
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  };

  return (
    <div className="col-sm-6">
      <section>
        <div className="gypsys-label">
          <h4>
            Gypsy's World
          </h4>
        </div>

      <div className='carousel-wrapper'>
          <div className="carousel-container">
            <Slider {...settings}>
              {images.map((image, index) => (
                <div key={index} className="carousel-item">
                  <img src={image.src} alt={image.alt} />
                  <div className="carousel-feedback">
                    <button className="like-btn" onClick={() => handleLike(index)}>
                      ❤️ Like (<span className="like-count">{likes[index]}</span>)
                    </button>
                    <div className="comment-box">
                      <input
                        type="text"
                        placeholder="Add comment"
                        className="comment-input"
                        onKeyDown={(e) => handleComment(e, index)}
                        />
                      <ul className="comment-list">
                        {comments[index].map((comment, i) => (
                          <li key={i}>{comment}</li>
                          ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
    </div>
  );
};

const RubiksGallery = () => {
  useEffect(() => {
    const images = document.querySelectorAll('#rubiksContainer img');

    const handleClick = function () {
      const temp = this.src;
      this.src = this.getAttribute('data-alt-src');
      this.setAttribute('data-alt-src', temp);
    };

    images.forEach((img) => {
      img.addEventListener('click', handleClick);
    });

    return () => {
      images.forEach((img) => {
        img.removeEventListener('click', handleClick);
      });
    };
  }, []);

  return (
    <div className="col-sm-6">
      <div id="rubiksContainer">
        <div className="rubiksCode">
          <img
            src="/picz/ideaz11.jpg"
            data-alt-src="/picz/rubikz1.jpg"
            alt="Rubik 1"
            className="img-responsive"
          /><br />
          <img
            src="/picz/ideaz2.jpg"
            data-alt-src="/picz/rubikz2.jpg"
            alt="Rubik 2"
            className="img-responsive"
          /><br />
          <img
            src="/picz/ideaz3.jpg"
            data-alt-src="/picz/rubikz3.jpg"
            alt="Rubik 3"
            className="img-responsive"
          /><br /><br />
        </div>
      </div>
    </div>
  );
};

const GypsyPage = () => {
  return (
    <div className="row" style={{ paddingBottom: '3rem' }}>
      <GypsyCarousel />
      <RubiksGallery />
    </div>
  );
};

export default GypsyPage;
